import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { map, isEmpty } from 'lodash';
import { bool, shape, arrayOf, func, string } from 'prop-types';
import {
  makeStyles,
  Button,
  Tooltip,
} from '@material-ui/core';

import {
  AlertDialog,
} from '../../../../components';
import { getI18n } from '../../../../utils/intl';
import styles from './styles';
import {
  ALERT_ERROR,
} from '../../../../constants';

export const processErrors = (errors, defaultMessage) => {
  let errorMessage;
  if (errors.length > 0) {
    errorMessage = map(errors, (validationError) => validationError.error).join('\n');
  }
  return errorMessage || defaultMessage;
};

export const ActionsRaw = (props) => {
  const useStyles = makeStyles(styles);
  const classes = useStyles();
  const {
    notifyMessages,
    deleteErrors,
    isDeleteSuccess,
    uuid,
    disabled,
  } = props;

  const intl = getI18n(useIntl());
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const openDeleteDialog = () => setShowDeleteDialog(true);
  const closeDeleteDialog = () => setShowDeleteDialog(false);

  const onDelete = () => {
    props.deleteAuth(uuid);
    closeDeleteDialog();
  };

  useEffect(() => {
    if (isDeleteSuccess) {
      localStorage.setItem('isAuthDeleteSuccess', true);
      window.location.href = '/publish/settings/authentication';
    }
  }, [isDeleteSuccess]);

  useEffect(() => {
    if (!isEmpty(deleteErrors)) {
      notifyMessages(
        processErrors(deleteErrors, intl.getI18nMessage('error.auth.delete')),
        ALERT_ERROR,
      );
    }
  }, [deleteErrors]);

  return (
    <div
      id="auth-settings-details-actions-container"
      data-apim-test={'auth-settings-details-actions-container'}
    >
      {showDeleteDialog &&
        <AlertDialog
          id="auth-settings-details-delete-dialog"
          isOpen={showDeleteDialog}
          title={intl.getI18nMessage('label.delete.confirmation.title')}
          description={intl.getI18nMessage('label.auth.details.delete.confirmation.text')}
          submitText={intl.getI18nMessage('label.delete.button')}
          cancelText={intl.getI18nMessage('label.cancel.button')}
          onClose={closeDeleteDialog}
          onSubmit={onDelete}
          onCancel={closeDeleteDialog}
          submitButtonClass={classes.submitButton}
        />
      }
      {disabled ?
        <Tooltip
          arrow disableFocusListener disableTouchListener placement="top"
          title={intl.getI18nMessage('label.auth.delete.tooltip')}
        >
          <span>
            <Button
              id={"auth-settings-details-delete"}
              data-apim-test={"auth-settings-details-delete"}
              data-layer7-test={"auth-settings-details-delete"}
              variant="outlined"
              disabled={disabled}
              onClick={openDeleteDialog}
              className={classes.deleteButton}
            >
              {intl.getI18nMessage('label.delete.button')}
            </Button>
          </span>
        </Tooltip>
      :
        <Button
          id={"auth-settings-details-delete"}
          data-apim-test={"auth-settings-details-delete"}
          data-layer7-test={"auth-settings-details-delete"}
          variant="outlined"
          disabled={disabled || !uuid}
          onClick={openDeleteDialog}
          className={classes.deleteButton}
        >
          {intl.getI18nMessage('label.delete.button')}
        </Button>
      }
    </div>
  );
};

ActionsRaw.propTypes = {
  notifyMessages: func,
  uuid: string,
  deleteErrors: arrayOf(shape({})),
  userContext: shape({}),
  isDeleteSuccess: bool,
  deleteAuth: func,
  push: func,
  disabled: bool,
};
ActionsRaw.displayName = 'Actions';

export default ActionsRaw;
